import HomeIndex from "../pages/Home/Home";
import PaginaNoEncontrada from "../pages/PaginaNoEncontrada/PaginaNoEncontrada";
import Login from "../pages/Login/Login";

const listRoutesSegundoFactor = [
  {
    path: "/segundofactor/",
    component: Login,
    auth: false,
    title: "Login",
  },
  {
    path: "/segundofactor/home",
    component: HomeIndex,
    auth: false,
    title: "Home",
  },
  {
    path: "/segundofactor/404",
    component: PaginaNoEncontrada,
    auth: false,
    title: "Página no Encontrada",
  },
];

export default listRoutesSegundoFactor;
